import React, {  useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { X, ExclamationTriangle, Plus } from 'react-bootstrap-icons';
import { openLocalCaja } from '../../../../../../../../crud/management_api/locales_caja_management';
import { toast } from 'react-toastify';
import MiniLoadingSpinner from '../../../../../../../../components/Spinners/MiniLoadingSpinner';
import './OpenCaja.scss';
import { formatCurrency } from '../../../../../../../../utils/functions';


interface RenderModalProps {
  caja: any;
  cajas: any[];
  setCajas: (cajas: any[]) => void;
  show: boolean;
  setShow: (show: boolean) => void;
  onClose?: () => void;
  setActioncaja?: (closing: boolean) => void;
}

const OpenCaja: React.FC<RenderModalProps> = ({
  caja,
  cajas,
  setCajas,
  show,
  setShow,
  setActioncaja
}) => {
  const [initialAmount, setInitialAmount] = useState<number | null>(
    caja.final_amount ?? null
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Calculate differences for warnings
  const expectedAmount = caja.final_amount ?? 0;
  const declaredAmount = initialAmount ?? 0;
  const difference = declaredAmount - expectedAmount;


  const handleOpenCaja = () => {
    const user = JSON.parse(localStorage.getItem('user') ?? '{}');
    const userId = user ? Number(user.user_id) : 0;

    if (initialAmount === null) {
      toast.error('Debe ingresar un monto inicial válido');
      return;
    }

    setIsSubmitting(true);
    openLocalCaja(userId, caja.workstation_id, initialAmount!)
      .then((response) => {
        setCajas(
          cajas.map((c: any) =>
            c.workstation_id === caja.workstation_id ? response.data : c
          )
        );
        toast.success('Caja abierta');
        setShow(false);
        if (setActioncaja) setActioncaja(true);
      })
      .catch((error) => {
        console.error('Error opening caja: ', error);
        toast.error(error.response?.data?.message || 'Error al abrir la caja');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  if (isSubmitting) {
    return (
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Body>
          <MiniLoadingSpinner left="190px" />
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={() => setShow(false)} className="open-caja-modal" centered>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Abrir Caja</Modal.Title>
        </div>
        <Button variant="none" onClick={() => setShow(false)}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="amount-input-section">
          {/* Previous closing balance reference */}
          <div className="balance-reference">
            <span className="reference-label">Balance total cierre anterior de la caja:</span>
            <span className="reference-amount">{formatCurrency(expectedAmount)}</span>
          </div>
          
          <div className="form-field">
            <div className="field-label">Ingrese el monto inicial</div>
            <div className="amount-input-group">
              <div className="currency-symbol">$</div>
              <input
                type="text"
                className="amount-input"
                value={
                  initialAmount != null
                    ? initialAmount.toLocaleString('es-CR', {
                        maximumFractionDigits: 0,
                      })
                    : ''
                }
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, '');
                  setInitialAmount(onlyNums ? Number(onlyNums) : null);
                }}
                placeholder="0"
              />
            </div>
          </div>
        </div>

        {/* Warning banners */}
        {initialAmount !== null && initialAmount !== expectedAmount && (
          <>
            {difference < 0 && (
              <div className="warning-banner withdrawal-warning">
                <ExclamationTriangle className="warning-icon" />
                <div className="warning-content">
                  <div className="warning-title">Retiro de dinero</div>
                  <div className="warning-message">
                    Un retiro de dinero de <span className="amount-highlight">{formatCurrency(Math.abs(difference))}</span> será registrado
                  </div>
                </div>
              </div>
            )}
            
            {difference > 0 && (
              <div className="warning-banner deposit-warning">
                <Plus className="warning-icon" />
                <div className="warning-content">
                  <div className="warning-title">Abono de dinero</div>
                  <div className="warning-message">
                    Un abono de <span className="amount-highlight">{formatCurrency(difference)}</span> será registrado
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button
            variant="none"
            className="form-button-cancel"
            onClick={() => setShow(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="none"
            className="form-button-create"
            onClick={handleOpenCaja}
          >
            Abrir
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default OpenCaja;
